<template>
  <li class="nav__Item" v-if="enabled === true || enabled[item.id] || item.id === 'dashboard' || item.children">
    <router-link class="nav__ItemLink" :to="item.route" v-if="!item.children" :exact="checkRoot">
      <icon class="nav__ItemIcon" :name="item.icon"></icon>
      {{ $store.getters.getStringTranslation(item.label.replace(/\s/g, '').toLowerCase()) }}
    </router-link>

    <button class="nav__ItemLink" v-else @click="toggleSubmenu()" :class="{ 'is-Active': showSubmenu }">
      <icon class="nav__ItemIcon" :name="item.icon"></icon>

      {{ $store.getters.getStringTranslation(item.label.replace(/\s/g, '').toLowerCase()) }}
      <icon class="nav__ItemChevronIcon" name="chevron-down" :class="{ 'is-Active': showSubmenu }"></icon>
    </button>

    <ul v-if="item.children" class="nav__ItemSubmenu" :class="{ 'is-Active': showSubmenu }">
      <template class="nav__Item" v-for="item in item.children">
        <li :key="item.id" v-if="enabled === true || enabled[item.id]">
          <router-link class="nav__ItemLink" :to="item.route">
            <icon class="nav__ItemIcon" :name="item.icon"></icon>
            {{ $store.getters.getStringTranslation(item.label.replace(/\s/g, '').toLowerCase()) }}
          </router-link>
        </li>
      </template>
    </ul>
  </li>
</template>

<script>
export default {
  props: ['item'],
  name: 'NavItem',
  data() {
    return {
      showSubmenu: false,
    }
  },
  methods: {
    toggleSubmenu() {
      this.showSubmenu = !this.showSubmenu
    },
  },
  computed: {
    checkRoot() {
      if (this.item.route === '/') return true
      return false
    },
    enabled() {
      if (this.$store.state.accounts.org.websites && this.$store.state.websites.current[0]) {
        const currentApi = this.$store.state.websites.current[0]

        const current = this.$store.state.accounts.org.websites.find((website) => website.api_key === currentApi)
        if (current && current.additionals.defaults) return current.additionals.defaults.resources
      }

      return true
    },
  },
}
</script>
